import React, { useState, useEffect, Fragment } from 'react'
import axios from "axios";
import {
    Table,
    Button, Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import './Orders.css'
import ReactToPrint from 'react-to-print';
import Pagination from "react-js-pagination";
import { data } from 'jquery';
import { PrintDoc } from './PrintDoc';
import Skeleton from 'react-loading-skeleton';
const TodaysOrders = () => {
    const [orderDetails, setOrderDetails] = useState([])
    const [loading, setloading] = useState(true)
    const [itemsModel, setModal] = useState(false);
    const [confirmModel, setConfirmModel] = useState(false);
    const [dataItem, setDataItem] = useState([])
    const [pageCount, setPageCount] = useState(1)
    const [itemTotalCount, setItemTotalCount] = useState(0)
    const printReceipt = () => {
        var divContents = document.getElementById("print").innerHTML;
        var a = window.open('', '', 'height=500, width=500');
        a.document.write('<html>');
        a.document.write('<body style="width:300px" >');
        a.document.write(divContents);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }
    const toggleItems = (data) => {
        console.log("toggleItems -> data", data)
        setDataItem(data);
        setModal(!itemsModel);
    }


    const handlePageChange = (pageNumber) => {
        console.log("handlePageChange -> pageNumber", pageNumber)
        setPageCount(pageNumber);
        setloading(true)
        getOrderList();


    }

    const getOrderList = () => {
        const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: `https://api.chicking-malappuram.in/api/orders-today/?page=${pageCount}`,
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            if (res.data.length > 0) {
                setOrderDetails(res.data);
                let pageCount = res.data[0].page_count;
                let totalCount = (parseInt(pageCount) * 6);
                setItemTotalCount(totalCount);
                console.log("getOrderList -> pageCount", pageCount)


            }
            setloading(false)
            console.log("res", res)


        });
    }
    const getOrderListSearch = () => {
        const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: `https://api.chicking-malappuram.in/api/orders-today/?page=${pageCount}`,
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            if (res.data.length > 0) {
                setOrderDetails(res.data);
                let pageCount = res.data[0].page_count;
                let totalCount = (parseInt(pageCount) * 6);
                setItemTotalCount(totalCount);
                console.log("getOrderList -> pageCount", pageCount)


            }
            setloading(false)
            console.log("res", res)


        });
    }
    
    useEffect(() => {
        setloading(true)
        getOrderList();

    }, []);
    let textInput = React.createRef();

    function handleClick() {
    //   alert(textInput.current.value);
      const access = sessionStorage.getItem('access');
        axios({
            method: 'get',
            url: `https://api.chicking-malappuram.in/api/orders-today/?page=${pageCount}&phone=${textInput.current.value}`,
            headers: { 'Authorization': `Bearer ${access}` }
        }).then((res) => {
            console.log("res", res)
            if (res.data.length > 0) {
                console.log(res)
                setOrderDetails(res.data);
                let pageCount = res.data[0].page_count;
                let totalCount = (parseInt(pageCount) * 6);
                setItemTotalCount(totalCount);
                console.log("getOrderList -> pageCount", pageCount)
            }
            setloading(false)
            
        });
    }
    function todayOrders() {
        //   alert(textInput.current.value);
          const access = sessionStorage.getItem('access');
            axios({
                method: 'get',
                url: `https://api.chicking-malappuram.in/api/orders-today/?page=${pageCount}`,
                headers: { 'Authorization': `Bearer ${access}` }
            }).then((res) => {
                console.log("res", res)
                if (res.data.length > 0) {
                    setOrderDetails(res.data);
                    let pageCount = res.data[0].page_count;
                    let totalCount = (parseInt(pageCount) * 6);
                    setItemTotalCount(totalCount);
                    console.log("getOrderList -> pageCount", pageCount)
                }
                setloading(false)
                
            });
        }

    return (
        <Fragment>
            <div className="content">
                <Row>
                    <Col lg="12">
                        <div className="card chicking-card">
                            <div style={{width:"fit-content"}}className="pull-left">
                            <input ref={textInput} style={{padding:6,marginRight:5}} name="search" placeholder="search byphone number"></input>
                            <Button onClick={handleClick}>Search</Button>
                            </div>
                            
                          
                            {loading ? <Skeleton count={6} /> :
                                <React.Fragment>
                                    <Table striped>
                                        <thead>
                                            <tr>
                                                <th>Order Id</th>
                                                <th>Customer NAME</th>
                                                <th>Contact No</th>
                                                {/* <th>Address</th> */}
                                                <th>Outlet</th>
                                                <th>Order Type</th>
                                                <th>Total Amount</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? 'Loading...' : ''}
                                            {orderDetails && orderDetails.length > 0 &&
                                                orderDetails.map((data, index) =>
                                                    <tr key={data.id} className={data.status}>
                                                        <td>{data.id}</td>
                                                        <td>{data.name}</td>
                                                        <td>{data.number}</td>
                                                        {/* <td>{data.address}</td> */}
                                                        <td>{data.outlet}</td>
                                                        <td>{data.order_type}</td>
                                                        <td><p className="total">{`Rs. ${data.total}`}</p></td>
                                                        <td>{data.status}</td>

                                                        <td><Button color="danger" onClick={() => toggleItems(data)}>View Items</Button></td>
                                                    </tr>
                                                )}

                                        </tbody>
                                    </Table>
                                    <Pagination
                                        activePage={pageCount}
                                        itemsCountPerPage={6}
                                        totalItemsCount={itemTotalCount}
                                        onChange={handlePageChange}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </React.Fragment>
                            }
                        </div>
                    </Col>
                </Row>
            </div>

            {/* confirm modal */}
            {/* <Modal isOpen={confirmModel} toggle={toggleConfirm}>
                <ModalHeader toggle={toggleConfirm}>View Order Items</ModalHeader>
                <ModalBody>
                    <Table striped>
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataItem && dataItem.length > 0 &&
                                dataItem.map((data, index) =>
                                    <tr>
                                        <td>{data.item}</td>
                                        <td>{data.qty}</td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                </ModalBody>


            </Modal> */}


            {/* items Model */}
            <Modal isOpen={itemsModel} toggle={toggleItems}>
                <ModalHeader toggle={toggleItems}>View Order Items</ModalHeader>
                <ModalBody>
                    <Table striped ref={el => (this.componentRef = el)}>
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataItem.items && dataItem.items.length > 0 &&
                                dataItem.items.map((data, index) =>
                                    <tr>
                                        <td>{data.item}</td>
                                        <td>{data.qty}</td>
                                        <td>{data.remarks}</td>
                                    </tr>
                                )}
                        </tbody>
                    </Table>
                    <h6>Order Id :{dataItem.id} </h6>
                    <h6>Order taken by : {dataItem.staff}</h6>
                    <div className="address-box">
                    <h6>Outlet :{dataItem.outlet} </h6>
                        <h4>Customer Details:</h4>
                        <h6>{dataItem.name}</h6>
                        <h6>{dataItem.number}</h6>
                        <p>{dataItem.address}</p>
                        {/* <h5>Notes:</h5>
                        <p>{dataItem.notes}</p> */}
                        <h6>Ordered on : {dataItem.time}</h6>
                        <h6>confirmed at : {dataItem.confirmed_time}</h6>
                        <h6>Dispathed at : {dataItem.dispatched_time}</h6>
                    </div>
                    {/* <ReactToPrint
                        trigger={() => {
                            // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                            // to the root node of the returned component as it will be overwritten.
                            return <Button color="danger" >Print</Button>;
                        }}
                        content={() => <PrintDoc/>}
                    /> */}
                    <div id="print">
                        <h4 style={{textAlign:"center"}}className="text-center">chicking {dataItem.outlet}</h4>
                        <hr />
                        <p style={{textAlign:"center"}}className="text-center">{dataItem.confirmed_time}</p>
                        <hr />
                        <span style={{width:"100%", display:"block"}}><b>Name: </b>{dataItem.name}</span>
                        <span style={{width:"100%", display:"block"}}><b>Address: </b>{dataItem.address}</span>
                        <span style={{width:"100%", display:"block"}}><b>phone: {dataItem.number}</b></span>
                        <hr />
                        <h4 style={{textAlign:"center"}}className="text-center">Order</h4>
                        <table className="table">
                        {dataItem.items && dataItem.items.length > 0 &&
                                dataItem.items.map((data, index) =>
                                    <tr>
                                        <td><b>{data.qty}</b> X {data.item} </td>
                                        <td>{data.remarks}</td>
                                    </tr>
                                )}
                        </table>
                        <hr />
                        <h4>Thank you</h4>
                    </div>
                    <td><Button color="danger" onClick={() => printReceipt()}>Print</Button></td>
                </ModalBody>


            </Modal>
        </Fragment>
    )
}


export default TodaysOrders
